import * as React from "react";
import { memo } from "react";
const SvgModalCloseButton = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle opacity={0.2} cx={12} cy={12} r={12} fill="#A6A9BA" />
    <g clipPath="url(#clip0_1503_61903)">
      <path
        d="M15.5999 15.5984L8.3999 8.39844"
        stroke="#14181F"
        strokeOpacity={0.5}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5999 8.39844L8.3999 15.5985"
        stroke="#14181F"
        strokeOpacity={0.5}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1503_61903">
        <rect
          width={9.6}
          height={9.6}
          fill="white"
          transform="translate(7.19995 7.19922)"
        />
      </clipPath>
    </defs>
  </svg>
);
const Memo = memo(SvgModalCloseButton);
export default Memo;

